document.addEventListener('DOMContentLoaded', function() {
  function positionTimelineLines() {
    const timelineContainers = document.querySelectorAll('.timeline-events-container');
    
    timelineContainers.forEach(container => {
      const eventsContainer = container.querySelector('.timeline-events');
      const events = eventsContainer.querySelectorAll('.timeline-event');
      if (events.length < 2) return;
      
      // Get the first event number element to calculate vertical position
      const firstEventNumber = events[0].querySelector('.timeline-event-number');
      const firstDot = events[0].querySelector('.timeline-event-dot');
      const lastDot = events[events.length - 1].querySelector('.timeline-event-dot');
      
      if (!firstEventNumber || !firstDot || !lastDot) return;
      
      const solidLine = eventsContainer.querySelector('.timeline-solid-line');
      const dottedLine = container.querySelector('.timeline-dotted-line');
      
      // Get the positions
      const containerRect = container.getBoundingClientRect();
      const eventsRect = eventsContainer.getBoundingClientRect();
      const numberRect = firstEventNumber.getBoundingClientRect();
      const firstDotRect = firstDot.getBoundingClientRect();
      const lastDotRect = lastDot.getBoundingClientRect();
      
      // Calculate the vertical position (30px below the bottom of the number div)
      const topPosition = numberRect.bottom - containerRect.top + 30;
      
      // Position the dotted line - simple negative of container's left position
      dottedLine.style.top = `${topPosition}px`;
      dottedLine.style.left = `-${containerRect.left}px`;
      
      // Position the solid line relative to the scrollable container
      // Calculate positions relative to the events container since solid line is now inside it
      console.log(firstDotRect.left, eventsRect.left, firstDotRect.width);
      const leftPos = firstDotRect.left - eventsRect.left + (firstDotRect.width);
      const rightPos = eventsRect.right - lastDotRect.right + (lastDotRect.width);
      
      solidLine.style.top = `${topPosition - eventsRect.top + containerRect.top}px`;
      solidLine.style.left = `${leftPos}px`;
      solidLine.style.right = `${rightPos}px`;
    });
  }
  
  // Run on load and on resize
  positionTimelineLines();
  window.addEventListener('resize', positionTimelineLines);
  
  // Also run when images might have loaded and changed layout
  window.addEventListener('load', positionTimelineLines);
  
  
  // Check if IntersectionObserver is available for better performance
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          positionTimelineLines();
        }
      });
    });
    
    document.querySelectorAll('.timeline.section').forEach(section => {
      observer.observe(section);
    });
  }
});